import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';

import { environment } from '../../../../../environments/environment';
import { IsActive } from './../../../../model';
import { CheckType } from '../../../../../../node_modules/@angular/core/src/view';
import { isObject } from 'util';

@Injectable()
export class ServiceCallCreateService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe
  ) { }

  create(input): Observable<any> {
    const url = this.urlPrefix + 'service-calls';
    return this.http
      .post(url, {
        creationTime: input.creationTime,
        receivedTime: null,
        arrivedTime: input.arrivedTime,
        completedTime: input.completedTime,
        status: input.status,
        remarks: input.remarks,
        customerReport: input.customerReport,
        schedule: input.schedule,
        contactPerson: input.contactPerson,
        contactNumber: input.contactNumber,
        contactEmail: null,
        tentativeBeginDate: input.tentativeBeginDate,
        tentativeFinishDate: input.tentativeFinishDate,
        serviceBeginDate: input.serviceBeginDate,
        serviceFinishDate: input.serviceFinishDate,
        siteId: input.siteId,
        customerId: input.customerId,
        teamIds: input.teamIds,
        equipList: input.equipList,
        ecallId: input.ecallId,
        pmServiceId: input.pmServiceId,
        relatedServiceCallId: input.relatedServiceCallId,
        userAssignModels: input.userAssignModels
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 201) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-create/service-call-create.service.ts